import React from "react";
import { Button } from "react-bootstrap";
import "./styles/OutlinedButton.css";

export default function OutlinedButton({
  title,
  className,
  startIcon: StartIcon,
  endIcon: EndIcon,
  ...props
}) {
  return (
    <Button
      className={`outlined-button sf-outlined ${className ? className : ""}`}
      {...props}
      title='outline'
    >
      <div>
        {StartIcon ? <StartIcon className="start-icon" /> : null}
      </div>
      {title}
    </Button>
  );
}
